import axios from 'axios';

import { assertClientSide } from '@dr.pogodin/react-utils';

import type { GetUserAiProfileResT } from 'server/controllers/user';
import { E_AI_PROFILE, P_API_USERS, type UserProfileT } from 'utils';

export async function getUserAiProfile(
  userId: string,
): Promise<UserProfileT | null> {
  // TODO: Implement it - for the current PoC use the client-side implementation
  // is necessary and enough.
  assertClientSide();

  const res = await axios<GetUserAiProfileResT>(
    `${P_API_USERS}/${userId}${E_AI_PROFILE}`,
  );

  return res.data;
}
